import { Component } from '@angular/core';
import { AbstractBreezeListComponent } from '@common/classes/breeze-list';
import { ShippingManifestPermissions } from '@common/classes/permissions';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-cargo-agent-data-confirmation-modal',
    templateUrl: './cargo-agent-data-confirmation-modal.component.html',
    styleUrls: ['./cargo-agent-data-confirmation-modal.component.scss'],
    providers: [BreezeViewService]
})
export class CargoAgentDataConfirmationModalComponent extends AbstractBreezeListComponent {
    queryName: string = 'DataConfirmations';
    id: number;

    constructor(private breezeViewService: BreezeViewService,
        public activeModal: NgbActiveModal) {
        super(breezeViewService);
        this.persistFilter = false;
    }

    close() {
        this.activeModal.close(false);
    }

    getDefaultFilter() {
        return { vesselNotificationId: this.id };
    }

    canUnconfirm(confirmation: any) {
        return confirmation.completed && this.user.hasPermission(ShippingManifestPermissions.Action.unconfirm);
    }

    async unconfirm(confirmation: any) {
        await this.breezeViewService.handleCommand('UnconfirmCargoData', { id: this.id, confirmationId: confirmation.id });
        this.activeModal.close(true);
    }
}
